export default __webpack_public_path__ + "static/cruiselines-vrc-ship-10-d0446cb414d1dd4989865cf479f14454.jpg";